/**
 * NursingThreads Email Capture Widget
 * Exit-intent popup with unit segmentation
 * Version: 1.0.0
 * 
 * HOW TO INSTALL IN SHOPIFY:
 * 1. Go to Shopify Admin → Online Store → Themes
 * 2. Click "..." on your active theme → Edit code
 * 3. In Layout folder, open theme.liquid
 * 4. Paste the HTML (from email-capture.html) just before </body>
 * 5. Upload this file as email-capture.js to Assets, or paste inline
 * 6. Save
 */

(function () {
  'use strict';

  /* ================================
     CONFIGURATION
     ================================ */
  const CONFIG = {
    discountCode: 'NURSE10',
    discountPercent: 10,
    cookieExpiryDays: 7,
    // Set to true to use Shopify's native customer API
    useShopifyAPI: false,
    // Shopify store domain (for API mode)
    shopDomain: 'nursingthreads.com',
  };

  /* ================================
     DOM REFERENCES
     ================================ */
  const overlay = document.getElementById('ntOverlay');
  const closeBtn = document.getElementById('ntClose');
  const fab = document.getElementById('ntFab');
  const form = document.getElementById('ntForm');
  const formWrap = document.getElementById('ntFormWrap');
  const successPanel = document.getElementById('ntSuccess');
  const codeBox = document.getElementById('ntCode');
  const copyBtn = document.getElementById('ntCopyBtn');
  const emailInput = document.getElementById('ntEmail');
  const unitInput = document.getElementById('ntUnit');

  /* ================================
     STORAGE HELPERS
     ================================ */
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (r, v) {
      const parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
  }

  function hasCookie(name) {
    return document.cookie.includes(name + '=');
  }

  // Save submission to localStorage (works without backend)
  function saveSubmission(data) {
    const key = 'nt_submissions';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    data.submittedAt = new Date().toISOString();
    data.source = window.location.href;
    existing.push(data);
    localStorage.setItem(key, JSON.stringify(existing));
    return existing;
  }

  // Export submissions as downloadable JSON (for Mike to import to Klaviyo/Mailchimp)
  function exportSubmissions() {
    const data = localStorage.getItem('nt_submissions') || '[]';
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'nursingthreads-submissions-' + new Date().toISOString().split('T')[0] + '.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  /* ================================
     POPUP LOGIC
     ================================ */
  let shown = false;

  function openPopup() {
    if (shown || hasCookie('nt_popup_closed')) return;
    overlay.classList.add('active');
    shown = true;
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    // Remember close for 1 day (don't immediately re-show)
    setCookie('nt_popup_closed', '1', 1);
  }

  // Expose globally so Mike can trigger manually
  window.NursingThreadsWidget = {
    open: openPopup,
    close: closePopup,
    export: exportSubmissions,
  };

  /* ================================
     EXIT-INTENT DETECTION
     ================================ */
  // Desktop: mouse leaving viewport toward top
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY < 10) {
      openPopup();
    }
  });

  // Mobile: detect rapid scroll-up (user reaching for address bar)
  let lastScrollY = window.scrollY;
  let scrollUpCount = 0;
  window.addEventListener('scroll', function () {
    if (window.innerWidth > 768) return; // Only on mobile
    const current = window.scrollY;
    if (lastScrollY - current > 80) {
      scrollUpCount++;
      if (scrollUpCount >= 2) {
        openPopup();
        scrollUpCount = 0;
      }
    }
    lastScrollY = current;
  }, { passive: true });

  // Also show after 30 seconds if user is engaged ( scrolled > 50% page )
  setTimeout(function () {
    const scrollPercent = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if (scrollPercent > 0.5) {
      openPopup();
    }
  }, 30000);

  /* ================================
     EVENT LISTENERS
     ================================ */
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (fab) fab.addEventListener('click', openPopup);

  // Close on overlay click (but not popup click)
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
  }

  // Escape key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) {
      closePopup();
    }
  });

  /* ================================
     FORM SUBMISSION
     ================================ */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      
      const email = emailInput.value.trim().toLowerCase();
      const unit = unitInput.value;
      const submitBtn = document.getElementById('ntSubmit');
      
      if (!email || !unit) return;

      // Disable button to prevent double-submit
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      const payload = {
        email: email,
        unit: unit,
        code: CONFIG.discountCode,
      };

      // Save locally
      saveSubmission(payload);

      // Sync to Mike's email list (Brevo via revenue.michaelgaff.com)
      fetch('https://revenue.michaelgaff.com/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, store: 'nursing', unit: unit }),
      }).catch(function () { /* offline is fine — local copy kept */ });

      // Optional: send to Shopify customer API
      if (CONFIG.useShopifyAPI) {
        // This requires Shopify Plus or custom backend
        // For now, we just save locally
        console.log('[NursingThreads] Would sync to Shopify:', payload);
      }

      // Show success
      setTimeout(function () {
        formWrap.style.display = 'none';
        successPanel.classList.add('show');
        codeBox.textContent = CONFIG.discountCode;
        
        // Remember this user got the code
        setCookie('nt_subscribed', '1', CONFIG.cookieExpiryDays);
        
        // Fire optional conversion event for analytics
        if (window.gtag) {
          gtag('event', 'generate_lead', {
            currency: 'USD',
            value: 0,
          });
        }
        if (window.fbq) {
          fbq('track', 'Lead');
        }
      }, 600);
    });
  }

  /* ================================
     COPY CODE BUTTON
     ================================ */
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      const code = codeBox.textContent;
      navigator.clipboard.writeText(code).then(function () {
        copyBtn.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.textContent = 'Copy Code';
        }, 2000);
      }).catch(function () {
        // Fallback
        const range = document.createRange();
        range.selectNode(codeBox);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy Code'; }, 2000);
      });
    });
  }

  /* ================================
     AUTO-FILL FROM URL (UTM support)
     ================================ */
  (function () {
    const params = new URLSearchParams(window.location.search);
    const utmEmail = params.get('email');
    if (utmEmail && emailInput) {
      emailInput.value = utmEmail;
    }
  })();

  console.log('[NursingThreads] Email capture widget loaded. Type NursingThreadsWidget.export() in console to download submissions.');
})();
